module.exports = __webpack_public_path__ + "static/media/backhoe_white.65478fe5.svg";